import { createConfig, http } from 'wagmi'
import { connectorsForWallets } from '@rainbow-me/rainbowkit'
import {
	coinbaseWallet,
	injectedWallet,
	metaMaskWallet,
	walletConnectWallet,
	okxWallet,
	bitgetWallet
} from '@rainbow-me/rainbowkit/wallets'
import { match } from 'ts-pattern'

import spicyChain from './networks/spicy'
import mainnetChain from './networks/mainnet'
import stagingChain from './networks/staging'
import type { Chain, HttpTransport } from 'viem'
import { NetworkId } from '@/types/network'
import { sociosWallet } from './socios-wallet'

function getChains() {
	const [first, ...rest] = match(import.meta.env.VITE_ENV)
		.with('integration', () => [stagingChain, spicyChain, mainnetChain])
		.with('staging', () => [stagingChain, spicyChain, mainnetChain])
		.with('spicy', () => [spicyChain])
		.otherwise(() => [mainnetChain])

	return [first, ...rest] satisfies [Chain, ...Chain[]]
}

const connectors = connectorsForWallets(
	[
		{
			groupName: 'Recommended',
			wallets: [
				sociosWallet,
				metaMaskWallet,
				coinbaseWallet,
				walletConnectWallet,
				injectedWallet,
				okxWallet,
				bitgetWallet
			]
		}
	],
	{
		appName: import.meta.env.VITE_APP_NAME,
		projectId: import.meta.env.VITE_PROJECT_ID // Every dApp that relies on WalletConnect now needs to obtain a projectId from WalletConnect Cloud. This is absolutely free and only takes a few minutes.
	}
)

const configuredChains = getChains()

export const wagmiConfig = createConfig({
	connectors,
	chains: configuredChains,
	transports: configuredChains.reduce(
		(acc, chain) => ({
			...acc,
			[chain.id]: http()
		}),
		{} as Record<NetworkId, HttpTransport>
	),
	ssr: false
})
